import React from 'react';
import PropTypes from 'prop-types';
import { BoxWithHeading, Alert, Markdown, Box } from '@honda-canada/design-system-react';
import themeStyles from '../ServiceNotices/styles/ServiceNotices.styles';
import generateDataTestId from '../../utils/generateDataTestId';
import useConfiguration from '../../hooks/useConfiguration';
import componentConfig from './componentConfig';

const HeadingBox = themeStyles.apply(BoxWithHeading, 'Container');
const TextAmount = themeStyles.apply('span', 'TextAmount');
const TitleText = themeStyles.apply('span', 'TitleText');
const BoxWithBorder = themeStyles.apply(Box, 'BoxWithBorder');
const BoxWithoutBorder = themeStyles.apply(Box, 'BoxWithoutBorder');
const Subtitle = themeStyles.apply('span', 'Subtitle');

const BoxWithAlert = ({ title, amountIdentifier, text, subtitle, showOpeningParagraph, isBordered = true }) => {
  const { counterColour, iconBackGround } = useConfiguration(componentConfig);

  if (!title || !text) {
    return null;
  }
  const AlertBox = isBordered ? BoxWithBorder : BoxWithoutBorder;
  const noticeTitle = title.split(' ')[0].toLowerCase();

  const titleContent = (
    <>
      <TitleText data-testid={`cy-heading-${noticeTitle}`}>{title}</TitleText>
      <TextAmount data-testid={generateDataTestId(title, 'counter')} counterColour={counterColour}>
        {amountIdentifier}
      </TextAmount>
    </>
  );

  const subtitleContent = showOpeningParagraph ? (
    <Subtitle data-testid={generateDataTestId(title, 'subtitle')}>{subtitle}</Subtitle>
  ) : null;

  return (
    <HeadingBox
      subtitleSize="regular"
      headingLevel="h4"
      titleContent={titleContent}
      bg="white"
      pt={['l', 'xxl']}
      pb={['l', 'zero']}
      subtitleContent={subtitleContent}
      shouldDisplayHeading="true"
      data-testid={`cy-service-notices-${noticeTitle}`}
    >
      <AlertBox width={[1, 10 / 12]}>
        <Box maxWidth={['280px', '280px', '613px']} mt={['m', 'l']} mx="auto">
          <Alert
            variant="success"
            // TODO update DSR to apply white bg color to icon
            iconStyle={{ background: iconBackGround }}
            dataTestId={generateDataTestId(title, 'alert')}
          >
            <Markdown
              size="small"
              fontSize="14px"
              lineHeight="22px"
              fontFamily="bold"
              letterSpacing="0.5px"
              color="black"
            >
              {text}
            </Markdown>
          </Alert>
        </Box>
      </AlertBox>
    </HeadingBox>
  );
};

BoxWithAlert.propTypes = {
  isBordered: PropTypes.bool,
  title: PropTypes.string,
  amountIdentifier: PropTypes.string,
  text: PropTypes.string,
  subtitle: PropTypes.string,
  showOpeningParagraph: PropTypes.bool,
};

export default BoxWithAlert;
